import {
  FETCH_GROUPS_SUCCESS,
  ADD_GROUP_SUCCESS,
  ASSIGN_TEACHER_SUCCESS,
  UNASSIGN_TEACHER_SUCCESS,
  FETCH_TEACHERS_BY_GROUP_SUCCESS,
  UPDATE_GROUP_SUCCESS,
  FETCH_GROUP_BY_ID_SUCCESS,
} from "../actions/groupActions";

const initialState = {
  groups: [],
  groupTeachers: {}, // { [group_id]: [teachers] }
};

const groupReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GROUPS_SUCCESS:
      return { ...state, groups: action.payload };
    case ADD_GROUP_SUCCESS:
      return { ...state, groups: [...state.groups, action.payload] };
    case FETCH_TEACHERS_BY_GROUP_SUCCESS:
      return {
        ...state,
        groupTeachers: {
          ...state.groupTeachers,
          [action.payload.group_id]: action.payload.teachers,
        },
      };
    case ASSIGN_TEACHER_SUCCESS: {
      const { group_id, user_id } = action.payload;
      return {
        ...state,
        groupTeachers: {
          ...state.groupTeachers,
          [group_id]: [...(state.groupTeachers[group_id] || []), user_id],
        },
      };
    }
    case UNASSIGN_TEACHER_SUCCESS: {
      const { group_id, user_id } = action.payload;
      return {
        ...state,
        groupTeachers: {
          ...state.groupTeachers,
          [group_id]: state.groupTeachers[group_id].filter(
            (teacher) => teacher.user_id !== user_id
          ),
        },
      };
    }
    case UPDATE_GROUP_SUCCESS: {
      const updatedGroup = action.payload;
      return {
        ...state,
        groups: state.groups.map((group) =>
          group.group_id === updatedGroup.group_id ? updatedGroup : group
        ),
      };
    }    
    case FETCH_GROUP_BY_ID_SUCCESS:
      return {
        ...state,
        currentGroup: action.payload,
      };
    default:
      return state;
  }
};

export default groupReducer;
